import { useMemo } from 'react';

import { ReportProblemOutlined } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';

import {
  ExpiredBannerType,
  useExpiredBannerContent
} from '@/components/ExpiredBanner/hooks/useExpiredBannerContent';
import UpgradeToPremiumButton from '@/components/UpgradeToPremium/UpgradeToPremiumButton';
import { formatDaysLeft } from '@/utils/formatString';

export const ExpiredBanner = () => {
  const banner = useExpiredBannerContent();

  const content = useMemo(() => {
    if (!banner) return;
    switch (banner.type) {
      case ExpiredBannerType.expired:
        return (
          <>
            <Typography>You no longer have access. Upgrade now for full access.</Typography>
            <UpgradeToPremiumButton type='expired' />
          </>
        );
      case ExpiredBannerType.trialEndingSoon:
        return (
          <>
            <Typography component='div'>
              Your trial ends in{' '}
              <Box sx={{ display: 'inline', fontWeight: 700 }}>
                {formatDaysLeft(banner.daysLeft)}
              </Box>
            </Typography>
            <UpgradeToPremiumButton type='expired' />
          </>
        );
      case ExpiredBannerType.subscriptionEndingSoon:
        return (
          <>
            <Box sx={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
              <ReportProblemOutlined sx={{ fontSize: 64 }} />
              <Box sx={{ maxWidth: '650px' }}>
                <Typography
                  sx={{ fontWeight: 700, mb: '6px' }}
                  variant='h5'
                >
                  Your {banner.subscription} subscription is ending soon
                </Typography>
                <Typography component='div'>
                  Your GX Go {banner.subscription} plan will expire in{' '}
                  <Box sx={{ display: 'inline', fontWeight: 700 }}>
                    {formatDaysLeft(banner.daysLeft)}
                  </Box>
                  . Renew now to maintain uninterrupted access to premium features.
                </Typography>
              </Box>
            </Box>
            <UpgradeToPremiumButton type='manage' />
          </>
        );
    }
  }, [banner]);

  return (
    content && (
      <Box
        sx={{
          background: '#1A224D',
          display: 'flex',
          justifyContent: 'space-between',
          gap: '16px',
          alignItems: 'center',
          px: '16px',
          py: '8px',
          mb: '24px'
        }}
      >
        {content}
      </Box>
    )
  );
};
